function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var SaitoUserTemplate = require('./../../lib/saito/ui/saito-user/saito-user.template.js');
var Link = require('./../../lib/saito/ui/saito-link/link');
var saito = require('../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var ChatMain = require('./lib/appspace/main');
var SaitoHeader = require('./../../lib/saito/ui/saito-header/saito-header');
var ChatManager = require('./lib/chat-manager/main');
var ChatManagerOverlay = require('./lib/overlays/chat-manager');
var JSON = require('json-bigint');
var Transaction = require('../../lib/saito/transaction')["default"];
var PeerService = require('saito-js/lib/peer_service')["default"];
var ChatSettings = require('./lib/overlays/chat-manager-menu');
var ChatSidebar = require('./lib/appspace/chat-sidebar');
var HomePage = require('./index');
var Chat = /*#__PURE__*/function (_ModTemplate) {
  function Chat(app) {
    var _this;
    _classCallCheck(this, Chat);
    _this = _callSuper(this, Chat, [app]);
    _this.name = 'Chat';
    _this.slug = 'chat';
    _this.description = 'Saito instant-messaging client';
    _this.categories = 'Messaging Chat';
    _this.groups = [];

    /*
     Array of:
     {
        id: id,
        members: members, //Array of publicKeys
        member_ids: {} // Key->value pairs  :admin / :1 / :0 -- group admin, confirmed, unconfirmed member
        name: name,
        unread: 0, //Number of new messages
        txs: [],
        // Processed TX:
        {
            sig = "string" //To helpfully prevent duplicates??
            ts = number
            from = "string" //Assuming only one sender
            msg = "" // raw message
            notice = (optional) flag that the tx is not really a chat message, but meta data
            mentioned = array of keys for saito mention
            flag_message = (optional) flag that message is a notification to me
        }
        last_update
    }
    */

    _this.inTransitImageMsgSig = null;
    _this.added_identifiers_post_load = 0;
    _this.communityGroup = null;
    _this.communityGroupName = 'Saito Community Chat';
    _this.debug = false;
    _this.chat_manager = null;
    _this.chat_manager_overlay = null;
    _this.loading = true;
    _this.enable_profile_edits = true;
    _this.isRelayConnected = false;
    _this.audio_notifications = true;
    _this.audio_chime = 'Glass';
    _this.auto_open_community = false;
    _this.online = false;
    _this.black_list = [];
    _this.app.connection.on('encrypt-key-exchange-confirm', function (data) {
      var group = _this.returnOrCreateChatGroupFromMembers(data === null || data === void 0 ? void 0 : data.members);
      _this.app.connection.emit('chat-manager-render-request');
      //Refresh the chat app if you are in it
      _this.app.connection.emit('chat-manager-opens-group', group);
    });
    _this.app.connection.on('remove-user-from-chat-group', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(group_id, member_id) {
        var group;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              group = _this.returnGroup(group_id);
              if (!group) {
                _context.n = 1;
                break;
              }
              if (!(group.members.includes(member_id) && (group === null || group === void 0 ? void 0 : group.member_ids[_this.publicKey]) == 'admin')) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return _this.sendRemoveMemberTransaction(group, member_id);
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.app.connection.on('chat-ready', function () {
      if (_this.auto_open_community) {
        _this.app.connection.emit('chat-popup-render-request');
      } else {
        _this.app.connection.emit('chat-manager-render-request');
      }
    });
    _this.app.connection.on('chat-message-user', function (pkey, message) {
      var group;
      if (pkey.toLowerCase() == 'community') {
        group = _this.returnCommunityChat();
      } else {
        group = _this.returnOrCreateChatGroupFromMembers([_this.publicKey, pkey]);
      }
      _this.createChatTransaction(group.id, message);
    });
    app.connection.on('saito-server-listening', function () {
      var _iterator = _createForOfIteratorHelper(_this.groups),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var g = _step.value;
          var _iterator2 = _createForOfIteratorHelper(g.txs),
            _step2;
          try {
            var _loop = function _loop() {
              var t = _step2.value;
              var link = app.browser.extractFirstValidURL(t.msg);
              if (link) {
                t.link = link;
                app.server.fetchOpenGraphProperties(t.link, function (res) {
                  t.link_properties = res;
                });
              }
            };
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    _this.postScripts = ['/saito/lib/emoji-picker/emoji-picker.js'];
    _this.social = {
      twitter: '@SaitoOfficial',
      title: 'Saito Chat',
      url: 'https://saito.io/chat/',
      description: 'Instant messaging client on Saito Network blockchain',
      image: 'https://saito.tech/wp-content/uploads/2022/04/saito_card_horizontal.png'
    };
    return _this;
  }
  _inherits(Chat, _ModTemplate);
  return _createClass(Chat, [{
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings(container) {
      var as = new ChatSettings(this.app, this, container);
      as.render();
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(Chat, "initialize", this, 3)([app]);
            case 1:
              if (!(app.BROWSER == 0)) {
                _context2.n = 3;
                break;
              }
              this.communityGroup = this.returnOrCreateChatGroupFromMembers([this.publicKey], this.communityGroupName);
              this.communityGroup.members = [this.publicKey];

              //
              // Chat server hits archive on boot up so it has something to return
              // on chat history request
              _context2.n = 2;
              return this.getOlderTransactions(this.communityGroup.id, 'localhost');
            case 2:
              return _context2.a(2);
            case 3:
              //
              // BROWSERS ONLY
              //

              this.loadOptions();
              this.chime = new Audio("/saito/sound/".concat(this.audio_chime, ".mp3"));
              _context2.n = 4;
              return this.loadChatGroups();
            case 4:
              //Add script for emoji to work
              this.attachPostScripts();
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x3) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var chat_id, chat_group, search, newtx;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (!(this.main == null)) {
                _context3.n = 3;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context3.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.header.header_class = 'wide-screen';
              this.addComponent(this.header);
              this.main = new ChatMain(this.app, this);
              this.addComponent(this.main);
              this.addComponent(new ChatSidebar(this.app, this));
            case 3:
              if (this.chat_manager == null) {
                this.chat_manager = new ChatManager(this.app, this);
                this.addComponent(this.chat_manager);
              }
              this.chat_manager.container = '.saito-sidebar.left';
              if (!(this.app.browser.isMobileBrowser(navigator.userAgent) && window.innerWidth < 750) && window.innerWidth > 599) {
                this.chat_manager.chat_popup_container = '.saito-main';
              }
              this.chat_manager.render_popups_to_screen = 0;
              this.chat_manager.render_manager_to_screen = 1;
              this.styles = ['/chat/style.css'];
              _context3.n = 4;
              return _superPropGet(Chat, "render", this, 3)([]);
            case 4:
              chat_id = this.app.browser.returnURLParameter('chat_id');
              if (!chat_id) {
                _context3.n = 9;
                break;
              }
              if (!this.app.wallet.isValidPublicKey(chat_id)) {
                _context3.n = 5;
                break;
              }
              //data.key = public key(s) of other chat parties
              this.app.connection.emit('open-chat-with', {
                key: chat_id
              });
              _context3.n = 8;
              break;
            case 5:
              chat_group = JSON.parse(this.app.crypto.base64ToString(chat_id));
              console.log('CHAT LINK:', chat_group);
              search = this.returnGroup(chat_group.id);
              if (!search) {
                _context3.n = 6;
                break;
              }
              //data.id = group id
              this.app.connection.emit('open-chat-with', {
                id: chat_group.id
              });
              _context3.n = 8;
              break;
            case 6:
              _context3.n = 7;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.publicKey);
            case 7:
              newtx = _context3.v;
              newtx.msg = chat_group;
              this.receiveCreateGroupTransaction(newtx);
            case 8:
              window.history.replaceState({}, document.title, '/' + this.slug);
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, peer) {
        var _this2 = this;
        var service,
          chat_self,
          _this$communityGroup,
          connectedPeers,
          i,
          _this$groups$i,
          old_peer,
          should_delete,
          _iterator3,
          _step3,
          _peer,
          msg,
          now,
          _iterator4,
          _step4,
          group,
          last_update,
          _args4 = arguments,
          _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              service = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              chat_self = this;
              this.online = true;
              if (app.BROWSER) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (service.service === 'relay') {
                this.isRelayConnected = true;
                this.app.connection.emit('chat-manager-render-request');
              }

              //
              // load private chat
              //
              if (service.service === 'archive') {
                if (this.debug) {
                  console.log('Chat: onPeerServiceUp', service.service);
                }
                this.loading = 0;

                /* We shouldn't need to fall back to archive to retrieve offline messages anymore... maybe
                 this.loading = this.groups.length;
                 for (let group of this.groups) {
                  //Let's not hit the Archive for community chat since that is seperately queried on service.service == chat
                  if (group.name !== this.communityGroupName) {
                    await this.app.storage.loadTransactions(
                      {
                        field3: group.id,
                        limit: 100,
                        created_later_than: group.last_update
                      },
                      async (txs) => {
                        chat_self.loading--;
                         if (txs) {
                          while (txs.length > 0) {
                            //Process the chat transaction like a new message
                            let tx = txs.pop();
                            await tx.decryptMessage(chat_self.app);
                            chat_self.addTransactionToGroup(group, tx);
                          }
                        }
                      }
                    );
                  }
                }*/
              }

              //
              // load public chat
              //
              if (!(service.service === 'chat')) {
                _context4.n = 11;
                break;
              }
              if (this.debug) {
                console.log('Chat: onPeerServiceUp', service.service);
              }
              if (!(this !== null && this !== void 0 && (_this$communityGroup = this.communityGroup) !== null && _this$communityGroup !== void 0 && (_this$communityGroup = _this$communityGroup.members) !== null && _this$communityGroup !== void 0 && _this$communityGroup.includes(peer.publicKey))) {
                _context4.n = 2;
                break;
              }
              console.log('Reconnect to chat service peer');
              return _context4.a(2);
            case 2:
              this.communityGroup = this.returnOrCreateChatGroupFromMembers([peer.publicKey], this.communityGroupName);
              if (!this.communityGroup) {
                _context4.n = 4;
                break;
              }
              this.communityGroup.members = [peer.publicKey];
              this.communityGroup.description = 'an open forum for anyone on Saito to chat';

              //
              // remove duplicate public chats caused by server update
              //
              _context4.n = 3;
              return this.app.network.getPeers();
            case 3:
              connectedPeers = _context4.v;
              for (i = this.groups.length; i >= 0; i--) {
                if (((_this$groups$i = this.groups[i]) === null || _this$groups$i === void 0 ? void 0 : _this$groups$i.name) === this.communityGroup.name && this.groups[i].id !== this.communityGroup.id && this.groups[i].members.length == 1) {
                  console.log('New community chat server... need to update');
                  old_peer = this.groups[i].members[0];
                  should_delete = true;
                  _iterator3 = _createForOfIteratorHelper(connectedPeers);
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      _peer = _step3.value;
                      if (old_peer == _peer.publicKey) {
                        should_delete = false;
                        console.log('Nevermind, still connected to old peer ' + old_peer);
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                  if (should_delete) {
                    this.app.connection.emit('chat-popup-remove-request', this.groups[i]);
                    this.groups.splice(i, 0);
                  }
                }
              }

              // let newtx = await this.app.wallet.createUnsignedTransaction();
              msg = {
                request: 'chat history',
                group_id: this.communityGroup.id,
                timestamp: this.communityGroup.last_update
              };
              this.app.network.sendRequestAsTransaction('chat history', msg, function (txs) {
                _this2.loading--;
                if (_this2.debug) {
                  console.log('chat history callback: ' + txs.length);
                }
                // These are no longer proper transactions!!!!

                if (_this2.communityGroup.txs.length > 0) {
                  var most_recent_ts = _this2.communityGroup.txs[_this2.communityGroup.txs.length - 1].timestamp;
                  for (var _i = 0; _i < txs.length; _i++) {
                    if (txs[_i].timestamp > most_recent_ts) {
                      _this2.communityGroup.txs.push(txs[_i]);
                      _this2.communityGroup.unread++;
                    } else {
                      if (txs[_i].link_properties) {
                        for (var j = 0; j < _this2.communityGroup.txs.length; j++) {
                          if (_this2.communityGroup.txs[j].signature == txs[_i].signature) {
                            _this2.communityGroup.txs[j].link = txs[_i].link;
                            _this2.communityGroup.txs[j].link_properties = txs[_i].link_properties;
                            break;
                          }
                        }
                      }
                    }
                  }
                } else {
                  _this2.communityGroup.txs = txs;
                  _this2.communityGroup.unread = txs.length;
                }
                if (_this2.app.BROWSER) {
                  var active_module = app.modules.returnActiveModule();
                  if (app.browser.isMobileBrowser(navigator.userAgent) || window.innerWidth < 600 || active_module !== null && active_module !== void 0 && active_module.request_no_interrupts) {
                    _this2.app.connection.emit('chat-manager-request-no-interrupts');
                  }
                  _this2.app.connection.emit('chat-ready');
                }
              }, peer.publicKey);
            case 4:
              now = new Date().getTime();
              _iterator4 = _createForOfIteratorHelper(this.groups);
              _context4.p = 5;
              _iterator4.s();
            case 6:
              if ((_step4 = _iterator4.n()).done) {
                _context4.n = 8;
                break;
              }
              group = _step4.value;
              if (!(group.name !== this.communityGroupName)) {
                _context4.n = 7;
                break;
              }
              if (!(group.members.includes(peer.publicKey) || group !== null && group !== void 0 && group.temporary)) {
                _context4.n = 7;
                break;
              }
              last_update = (group === null || group === void 0 ? void 0 : group.last_update) || 0;
              if (!(now - last_update > 1000 * 60 * 60 * 24)) {
                _context4.n = 7;
                break;
              }
              console.log(group.name, JSON.stringify(group.members));
              console.log('Time since last update (s): ', (now - last_update) / 1000);
              console.log('Delete Chat group!');
              _context4.n = 7;
              return this.deleteChatGroup(group);
            case 7:
              _context4.n = 6;
              break;
            case 8:
              _context4.n = 10;
              break;
            case 9:
              _context4.p = 9;
              _t = _context4.v;
              _iterator4.e(_t);
            case 10:
              _context4.p = 10;
              _iterator4.f();
              return _context4.f(10);
            case 11:
              return _context4.a(2);
          }
        }, _callee4, this, [[5, 9, 10, 11]]);
      }));
      function onPeerServiceUp(_x4, _x5) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      // servers with chat service run plaintext community chat groups
      if (this.app.BROWSER == 0) {
        services.push(new PeerService(null, 'chat', this.communityGroupName));
      }
      return services;
    }
  }, {
    key: "respondTo",
    value: function respondTo(type) {
      var _obj$tx;
      var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var chat_self = this;
      var force = false;
      switch (type) {
        case 'chat-manager':
          if (this.chat_manager == null) {
            this.chat_manager = new ChatManager(this.app, this);
          }
          return this.chat_manager;
          break;
        case 'saito-game-menu':
        case 'saito-chat-popup':
          // Need to make sure this is created so we can listen for requests to open chat popups
          if (this.chat_manager == null) {
            this.chat_manager = new ChatManager(this.app, this);
          }
          //Don't want mobile chat auto popping up
          this.chat_manager.render_popups_to_screen = 0;
          if (this.chat_manager_overlay == null) {
            this.chat_manager_overlay = new ChatManagerOverlay(this.app, this);
          }
          return [{
            text: 'Chat',
            icon: 'fas fa-comments',
            callback: function callback(app, id) {
              // console.log('Render Chat manager overlay');
              chat_self.chat_manager_overlay.render();
            },
            rank: 15,
            is_active: this.browser_active,
            event: function event(id) {
              chat_self.app.connection.on('chat-manager-render-request', function () {
                var unread = 0;
                var _iterator5 = _createForOfIteratorHelper(chat_self.groups),
                  _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    var group = _step5.value;
                    unread += group.unread;
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
                chat_self.app.browser.addNotificationToId(unread, id);
                //chat_self.app.connection.emit('saito-header-notification', 'chat', unread);
              });

              //Trigger my initial display
              chat_self.app.connection.emit('chat-manager-render-request');
            }
          }];
          break;
        case 'saito-header':
          if (chat_self.browser_active) {
            return null;
          }

          //
          // In mobile, we use the hamburger menu to open chat (without leaving the page)
          //
          if (this.app.browser.isMobileBrowser() || this.app.BROWSER && window.innerWidth < 600) {
            if (this.chat_manger) {
              //Don't want mobile chat auto popping up
              this.chat_manager.render_popups_to_screen = 0;
            }
            if (this.chat_manager_overlay == null) {
              this.chat_manager_overlay = new ChatManagerOverlay(this.app, this);
            }
            return [{
              text: 'Chat',
              icon: 'fas fa-comments',
              type: 'quicklaunch',
              callback: function callback(app, id) {
                // console.log('Render Chat manager overlay');
                chat_self.chat_manager_overlay.render();
              },
              event: function event(id) {
                chat_self.app.connection.on('chat-manager-render-request', function () {
                  var unread = 0;
                  var _iterator6 = _createForOfIteratorHelper(chat_self.groups),
                    _step6;
                  try {
                    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                      var group = _step6.value;
                      unread += group.unread;
                    }
                  } catch (err) {
                    _iterator6.e(err);
                  } finally {
                    _iterator6.f();
                  }
                  chat_self.app.browser.addNotificationToId(unread, id);
                  chat_self.app.connection.emit('saito-header-notification', 'chat', unread);
                });

                //Trigger my initial display
                chat_self.app.connection.emit('chat-manager-render-request');
              },
              navigation: '/chat'
            }];
          } else {
            //
            // Otherwise we go to the main chat application
            //
            return [{
              text: 'Chat',
              icon: 'fas fa-comments',
              type: 'navigation',
              callback: function callback(app, id) {
                navigateWindow('/chat');
              }
            }];
          }
          return null;
        case 'user-menu':
          if ((obj === null || obj === void 0 ? void 0 : obj.publicKey) !== this.publicKey) {
            var dynamic_text = this.black_list.includes(obj.publicKey) ? 'Unblock and Chat' : 'Chat';
            return {
              text: dynamic_text,
              icon: 'far fa-comment-dots',
              callback: function callback(app, publicKey) {
                if (chat_self.chat_manager == null) {
                  chat_self.chat_manager = new ChatManager(chat_self.app, chat_self);
                }
                for (var i = 0; i < chat_self.black_list.length; i++) {
                  if (chat_self.black_list[i] == publicKey) {
                    chat_self.black_list.splice(i, 1);
                    break;
                  }
                }
                chat_self.saveOptions();
                chat_self.app.connection.emit('open-chat-with', {
                  key: publicKey,
                  activate: true
                });
              }
            };
          }
          return null;

        //
        // Abandoned code to duplicate user menu in saito-profile
        //
        case 'saito-profile-menu':
          if (obj !== null && obj !== void 0 && obj.publicKey) {
            if (chat_self.app.keychain.hasPublicKey(obj.publicKey) && obj.publicKey !== this.publicKey) {
              return {
                text: 'Chat',
                icon: 'far fa-comment-dots',
                callback: function callback(app, publicKey) {
                  if (chat_self.chat_manager == null) {
                    chat_self.chat_manager = new ChatManager(chat_self.app, chat_self);
                  }
                  chat_self.app.connection.emit('open-chat-with', {
                    key: publicKey
                  });
                }
              };
            }
          }
          return null;
        case 'call-actions':
          if (obj !== null && obj !== void 0 && obj.call_id) {
            if (this.chat_manager == null) {
              this.chat_manager = new ChatManager(this.app, this);
            }
            this.createFreshGroup('Saito Talk', obj.call_id);
            return [{
              text: 'Chat',
              icon: 'fa-regular fa-comments',
              callback: function callback(app) {
                app.connection.emit('open-chat-with', {
                  id: obj.call_id
                });
              },
              event: function event(id) {
                var group = chat_self.returnGroup(obj.call_id);
                if (group) {
                  chat_self.app.browser.addNotificationToId(group.unread, id);
                  chat_self.app.connection.on('chat-manager-render-request', function () {
                    chat_self.app.browser.addNotificationToId(group.unread, id);
                  });
                }
              }
            }];
          }
          break;
        case 'limbo-actions':
          if (obj !== null && obj !== void 0 && obj.call_id) {
            if (this.chat_manager == null) {
              this.chat_manager = new ChatManager(this.app, this);
            }
            this.createFreshGroup(obj.group_name, obj.call_id);
            return [{
              text: 'Chat',
              icon: 'fa-regular fa-comments',
              callback: function callback(app) {
                app.connection.emit('open-chat-with', {
                  id: obj.call_id
                });
              },
              event: function event(id) {
                var group = chat_self.returnGroup(obj.call_id);
                if (group) {
                  chat_self.app.browser.addNotificationToId(group.unread, id);
                  chat_self.app.connection.on('chat-manager-render-request', function () {
                    chat_self.app.browser.addNotificationToId(group.unread, id);
                  });
                }
              }
            }];
          }
          break;
        case 'ntfy-notification':
          console.log(JSON.stringify(obj));
          if (((_obj$tx = obj.tx) === null || _obj$tx === void 0 || (_obj$tx = _obj$tx.msg) === null || _obj$tx === void 0 ? void 0 : _obj$tx.module) != 'Chat') {
            return null;
          }
          var tx = obj.tx;
          var notification = obj.notification;

          //Add from.
          var from = this.app.keychain.returnIdentifierByPublicKey(tx.from[0].publicKey, true);
          if (tx.to.length = 2) {
            notification.title = 'Saito DM';
          } else {
            notification.title = 'Saito Chat';
          }
          notification.tags = ['envelope'];
          notification.message = 'From: ' + from + '\n';
          if (typeof tx.msg == 'string') {
            //was checking if JSON.parse(tx.msg).ct was a string but this was breaking on parsing bigint...
            notification.message += 'Message Encyrypted';
          } else {
            var _tx$msg, _tx$msg$message;
            // Make sure this is a Chat Notification!!!!
            if ((tx === null || tx === void 0 || (_tx$msg = tx.msg) === null || _tx$msg === void 0 ? void 0 : _tx$msg.module) !== 'Chat') {
              return null;
            }
            notification.message += (_tx$msg$message = tx.msg.message) === null || _tx$msg$message === void 0 ? void 0 : _tx$msg$message.substring(0, 50);
          }
          notification.actions = [{
            action: 'view',
            label: 'Open Saito',
            url: this.app.server.server.url + '/chat/'
          }];
          return notification;
        default:
          return _superPropGet(Chat, "respondTo", this, 3)([type]);
      }
    }
  }, {
    key: "createFreshGroup",
    value: function createFreshGroup(name, id) {
      if (this.returnGroup(id)) {
        return;
      }
      var chat_group = {
        id: id,
        members: this.communityGroup.members,
        //general chat services host key
        name: name,
        txs: [],
        unread: 0,
        temporary: true
        //
        // USE A TARGET Container if the chat box is supposed to show up embedded within the UI
        // Don't include if you want it to be just a chat popup....
        //
        //target_container: `.stun-chatbox .${this.remote_container}`,
      };
      this.groups.push(chat_group);
    }

    //
    // ---------- on chain messages ------------------------
    // ONLY processed if I am in the to/from of the transaction
    // so I will process messages I send to community, but not other peoples
    // it is mostly just a legacy safety catch for direct messaging
    //
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(blk, tx, conf) {
        var txmsg;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(Number(conf) == 0)) {
                _context5.n = 10;
                break;
              }
              if (!(this.app.BROWSER && !tx.isTo(this.publicKey))) {
                _context5.n = 1;
                break;
              }
              console.debug("Chat: browsers don't process random messages");
              return _context5.a(2);
            case 1:
              if (!tx.decryptMessage) {
                _context5.n = 2;
                break;
              }
              _context5.n = 2;
              return tx.decryptMessage(this.app);
            case 2:
              if (tx.returnMessage) {
                txmsg = tx.returnMessage();
              } else {
                txmsg = tx.msg;
              }
              if (!(!txmsg.module == 'Chat')) {
                _context5.n = 3;
                break;
              }
              return _context5.a(2);
            case 3:
              if (this.debug) {
                console.log('Chat onConfirmation: ' + txmsg.request);
              }
              if (!(txmsg.request == 'chat message')) {
                _context5.n = 4;
                break;
              }
              _context5.n = 4;
              return this.receiveChatTransaction(tx, blk);
            case 4:
              if (!(this.hasSeenTransaction(tx, Number(blk.id)) && this.app.BROWSER)) {
                _context5.n = 5;
                break;
              }
              console.log('***************Already processed! ', txmsg.request);
              return _context5.a(2);
            case 5:
              if (!(txmsg.request == 'chat group')) {
                _context5.n = 6;
                break;
              }
              _context5.n = 6;
              return this.receiveCreateGroupTransaction(tx);
            case 6:
              if (!(txmsg.request == 'chat join')) {
                _context5.n = 7;
                break;
              }
              _context5.n = 7;
              return this.receiveJoinGroupTransaction(tx);
            case 7:
              if (!(txmsg.request == 'chat update')) {
                _context5.n = 8;
                break;
              }
              _context5.n = 8;
              return this.receiveUpdateGroupTransaction(tx);
            case 8:
              if (!(txmsg.request == 'chat remove')) {
                _context5.n = 9;
                break;
              }
              _context5.n = 9;
              return this.receiveRemoveMemberTransaction(tx);
            case 9:
              if (!(txmsg.request == 'chat like')) {
                _context5.n = 10;
                break;
              }
              _context5.n = 10;
              return this.receiveChatLikeTransaction(tx, 1);
            case 10:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onConfirmation(_x6, _x7, _x8) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }() //
    // We have a Chat-services peer that does 2 things
    // 1) it uses archive to save all the chat messages passing through it
    // 2) it forwards all messages to everyone through Relay
    // Private messages are encrypted and will be ignored by other parties
    // but this is essential to receive unencrypted community chat messages
    // the trick is that receiveChatTransaction checks if the message is to a group I belong to
    // or addressed to me
    //
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          _txmsg$data,
          group,
          txs,
          _group,
          _iterator7,
          _step7,
          m,
          inner_tx,
          inner_message,
          peers,
          _peers,
          _args6 = arguments,
          _t2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              tx = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : null;
              peer = _args6.length > 2 ? _args6[2] : undefined;
              mycallback = _args6.length > 3 ? _args6[3] : undefined;
              if (!(tx == null)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, 0);
            case 1:
              _context6.n = 2;
              return tx.decryptMessage(app);
            case 2:
              //In case forwarding private messages
              txmsg = tx.returnMessage();
              if (txmsg.request) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2, 0);
            case 3:
              if (this.debug && txmsg.request.includes('chat ')) {
                console.log('Chat handlePeerTransaction: ' + txmsg.request);
              }
              if (!(txmsg.request === 'chat history')) {
                _context6.n = 6;
                break;
              }
              console.log('Chat history request for: ', peer.publicKey);
              group = this.returnGroup(txmsg === null || txmsg === void 0 || (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.group_id);
              if (group) {
                _context6.n = 4;
                break;
              }
              console.log("Group doesn't exist?");
              return _context6.a(2, 0);
            case 4:
              if (!mycallback) {
                _context6.n = 5;
                break;
              }
              txs = group.txs.filter(function (t) {
                var _txmsg$data2;
                return t.timestamp > (txmsg === null || txmsg === void 0 || (_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.timestamp) || t.link_properties;
              });
              mycallback(txs);
              return _context6.a(2, 1);
            case 5:
              return _context6.a(2, 0);
            case 6:
              if (!(txmsg.request == 'chat group')) {
                _context6.n = 7;
                break;
              }
              this.receiveCreateGroupTransaction(tx);
              return _context6.a(2);
            case 7:
              if (!(txmsg.request == 'chat spv update')) {
                _context6.n = 14;
                break;
              }
              console.log('CHAT: Receive update for group / message');
              _group = this.returnGroup(txmsg.data.group_id);
              if (!_group) {
                _context6.n = 14;
                break;
              }
              _iterator7 = _createForOfIteratorHelper(_group.txs);
              _context6.p = 8;
              _iterator7.s();
            case 9:
              if ((_step7 = _iterator7.n()).done) {
                _context6.n = 11;
                break;
              }
              m = _step7.value;
              if (!(m.signature === txmsg.data.new_message.signature)) {
                _context6.n = 10;
                break;
              }
              m.link = txmsg.data.new_message.link;
              m.link_properties = txmsg.data.new_message.link_properties;
              this.app.connection.emit('chat-popup-render-request', _group);
              return _context6.a(3, 11);
            case 10:
              _context6.n = 9;
              break;
            case 11:
              _context6.n = 13;
              break;
            case 12:
              _context6.p = 12;
              _t2 = _context6.v;
              _iterator7.e(_t2);
            case 13:
              _context6.p = 13;
              _iterator7.f();
              return _context6.f(13);
            case 14:
              if (!(txmsg.request === 'chat relay')) {
                _context6.n = 31;
                break;
              }
              inner_tx = new Transaction(undefined, txmsg.data);
              _context6.n = 15;
              return inner_tx.decryptMessage(app);
            case 15:
              inner_message = inner_tx.returnMessage();
              if (!this.hasSeenTransaction(inner_tx)) {
                _context6.n = 16;
                break;
              }
              console.warn('Relayed transaction already seen...');
              return _context6.a(2);
            case 16:
              if (!(inner_message.request == 'chat join')) {
                _context6.n = 17;
                break;
              }
              this.receiveJoinGroupTransaction(inner_tx);
              return _context6.a(2);
            case 17:
              if (!(inner_message.request == 'chat update')) {
                _context6.n = 18;
                break;
              }
              this.receiveUpdateGroupTransaction(inner_tx);
              return _context6.a(2);
            case 18:
              if (!(inner_message.request == 'chat remove')) {
                _context6.n = 19;
                break;
              }
              this.receiveRemoveMemberTransaction(inner_tx);
              return _context6.a(2);
            case 19:
              if (!(inner_message.request === 'chat like')) {
                _context6.n = 25;
                break;
              }
              if (!app.BROWSER) {
                _context6.n = 21;
                break;
              }
              _context6.n = 20;
              return this.receiveChatLikeTransaction(inner_tx);
            case 20:
              _context6.n = 23;
              break;
            case 21:
              if (!(app.BROWSER == 0)) {
                _context6.n = 23;
                break;
              }
              if (!tx.isTo(this.publicKey)) {
                _context6.n = 23;
                break;
              }
              _context6.n = 22;
              return app.network.getPeers();
            case 22:
              peers = _context6.v;
              peers.forEach(function (p) {
                if (p.publicKey !== peer.publicKey) {
                  app.network.sendTransactionWithCallback(tx, null, p.publicKey);
                }
              });
            case 23:
              if (!mycallback) {
                _context6.n = 24;
                break;
              }
              mycallback({
                payload: 'success',
                error: {}
              });
              return _context6.a(2, 1);
            case 24:
              return _context6.a(2, 0);
            case 25:
              if (!(app.crypto.isAesEncrypted(inner_message) || inner_message.request == 'chat message')) {
                _context6.n = 31;
                break;
              }
              if (!app.BROWSER) {
                _context6.n = 27;
                break;
              }
              _context6.n = 26;
              return this.receiveChatTransaction(inner_tx);
            case 26:
              _context6.n = 29;
              break;
            case 27:
              if (!tx.isTo(this.publicKey)) {
                _context6.n = 29;
                break;
              }
              _context6.n = 28;
              return app.network.getPeers();
            case 28:
              _peers = _context6.v;
              //
              // Addressed to chat server, so forward to all
              //
              //console.log('Community Chat, relay to all: ', txmsg);
              _peers.forEach(function (p) {
                //This is filtering for not receiving your chat tx back to you... but there are case where we do want that?
                //if (p.publicKey !== peer.publicKey) {
                app.network.sendTransactionWithCallback(tx,
                // the relay wrapped message
                null, p.publicKey);
                //}
              });
            case 29:
              if (!mycallback) {
                _context6.n = 30;
                break;
              }
              mycallback({
                payload: 'success',
                error: {}
              });
              return _context6.a(2, 1);
            case 30:
              return _context6.a(2, 0);
            case 31:
              return _context6.a(2, _superPropGet(Chat, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee6, this, [[8, 12, 13, 14]]);
      }));
      function handlePeerTransaction(_x9) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "notifyPeers",
    value: function () {
      var _notifyPeers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(data) {
        var peers, _iterator8, _step8, peer, message;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!(this.app.BROWSER == 1)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              _context7.n = 2;
              return this.app.network.getPeers();
            case 2:
              peers = _context7.v;
              _iterator8 = _createForOfIteratorHelper(peers);
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  peer = _step8.value;
                  if (peer.synctype == 'lite' && (peer === null || peer === void 0 ? void 0 : peer.status) !== 'disconnected') {
                    //
                    // fwd data to peer
                    //
                    message = {};
                    message.request = 'chat spv update';
                    message.data = data;
                    this.app.network.sendRequestAsTransaction(message.request, message.data, null, peer.publicKey);
                  }
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function notifyPeers(_x0) {
        return _notifyPeers.apply(this, arguments);
      }
      return notifyPeers;
    }() //
    // Create a n > 2 chat group (currently unencrypted)
    // We have a single admin (who can add additional members or kick people out)
    //
  }, {
    key: "sendCreateGroupTransaction",
    value: function () {
      var _sendCreateGroupTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(name) {
        var invitees,
          pk,
          id,
          newtx,
          i,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              invitees = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : [];
              pk = this.app.crypto.generateKeys();
              id = this.app.crypto.generatePublicKey(pk);
              this.app.keychain.addKey(id, {
                identifier: name,
                group: 1,
                privateKey: pk,
                watched: true
              });
              _context8.n = 1;
              return this.app.wallet.createUnsignedTransaction(this.publicKey, BigInt(0), BigInt(0));
            case 1:
              newtx = _context8.v;
              if (!(newtx == null)) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2);
            case 2:
              for (i = 0; i < invitees.length; i++) {
                if (invitees[i] !== this.publicKey) {
                  newtx.addTo(invitees[i]);
                }
              }
              newtx.msg = {
                module: 'Chat',
                request: 'chat group',
                name: name,
                admin: this.publicKey,
                id: id
              };
              _context8.n = 3;
              return newtx.sign();
            case 3:
              _context8.n = 4;
              return this.app.network.propagateTransaction(newtx);
            case 4:
              this.app.connection.emit('relay-transaction', newtx);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function sendCreateGroupTransaction(_x1) {
        return _sendCreateGroupTransaction.apply(this, arguments);
      }
      return sendCreateGroupTransaction;
    }()
  }, {
    key: "receiveCreateGroupTransaction",
    value: function () {
      var _receiveCreateGroupTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(tx) {
        var txmsg, newGroup, x, inviter;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (!tx.isTo(this.publicKey)) {
                _context9.n = 4;
                break;
              }
              txmsg = tx.returnMessage();
              console.log('Receiving group creation tx', txmsg);

              //I already have the group
              if (!this.returnGroup(txmsg.id)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              this.app.keychain.addKey(txmsg.id, {
                identifier: txmsg.name,
                group: 1,
                watched: true
              });
              newGroup = {
                id: txmsg.id,
                members: [txmsg.admin],
                member_ids: {},
                name: txmsg.name,
                txs: [],
                unread: 0,
                last_update: 0
              };
              for (x = 0; x < tx.to.length; x++) {
                if (!newGroup.members.includes(tx.to[x].publicKey)) {
                  newGroup.members.push(tx.to[x].publicKey);
                  newGroup.member_ids[tx.to[x].publicKey] = 1;
                }
              }
              newGroup.member_ids[txmsg.admin] = 'admin';
              this.groups.push(newGroup);
              this.saveChatGroup(newGroup);
              if (tx.isFrom(txmsg.admin)) {
                tx.msg.message = "<div class=\"saito-chat-notice\"><span class=\"saito-mention saito-address\" data-id=\"".concat(txmsg.admin, "\">").concat(this.app.keychain.returnUsername(txmsg.admin), "</span>\n              <span> created the group ").concat(txmsg.name, "</span></div>");
                tx.notice = true;
                this.addTransactionToGroup(newGroup, tx);
              }
              if (!(tx.isFrom(this.publicKey) && this.publicKey == txmsg.admin)) {
                _context9.n = 2;
                break;
              }
              // We have now generated a unique ID (transaction signature) for the chat group
              // and can create a link for anyone else to find it
              this.generateChatGroupLink(newGroup);
              _context9.n = 3;
              break;
            case 2:
              inviter = (txmsg === null || txmsg === void 0 ? void 0 : txmsg.sender) || txmsg.admin;
              _context9.n = 3;
              return this.sendJoinGroupTransaction(newGroup, inviter);
            case 3:
              //Update UI
              this.app.connection.emit('chat-manager-opens-group', newGroup);
              this.app.connection.emit('open-chat-with', {
                id: newGroup.id
              });
            case 4:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function receiveCreateGroupTransaction(_x10) {
        return _receiveCreateGroupTransaction.apply(this, arguments);
      }
      return receiveCreateGroupTransaction;
    }() //
    // We automatically send a confirmation when added to a chat group (just so that we can make sure that the user was successfully added)
    // But in the future, we may add a confirmation interface
    //
  }, {
    key: "sendJoinGroupTransaction",
    value: function () {
      var _sendJoinGroupTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(group, inviter) {
        var newtx;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(group.id);
            case 1:
              newtx = _context0.v;
              if (newtx) {
                _context0.n = 2;
                break;
              }
              return _context0.a(2);
            case 2:
              newtx.msg = {
                module: 'Chat',
                request: 'chat join',
                group_id: group.id,
                invited_by: inviter
              };

              //just to make sure those txs go through
              newtx.addTo(group.admin);
              if (group.admin !== inviter) {
                newtx.addTo(inviter);
              }
              _context0.n = 3;
              return newtx.sign();
            case 3:
              _context0.n = 4;
              return this.app.network.propagateTransaction(newtx);
            case 4:
              this.app.connection.emit('relay-send-message', {
                request: 'chat relay',
                recipient: group.members,
                data: newtx.toJson()
              });
            case 5:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function sendJoinGroupTransaction(_x11, _x12) {
        return _sendJoinGroupTransaction.apply(this, arguments);
      }
      return sendJoinGroupTransaction;
    }()
  }, {
    key: "receiveJoinGroupTransaction",
    value: function () {
      var _receiveJoinGroupTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(tx) {
        var txmsg, group, new_member;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              txmsg = tx.returnMessage();
              group = this.returnGroup(txmsg.group_id);
              if (group) {
                _context1.n = 1;
                break;
              }
              console.warn("Receiving chat group transaction from a group I don't know");
              return _context1.a(2);
            case 1:
              if (!tx.isTo(group.id)) {
                _context1.n = 3;
                break;
              }
              new_member = tx.from[0].publicKey;
              if (!(group.member_ids[new_member] == -1)) {
                _context1.n = 2;
                break;
              }
              console.log('Blacklisted member attempting to rejoin!');
              return _context1.a(2);
            case 2:
              if (!group.members.includes(new_member)) {
                group.members.push(new_member);
                tx.msg.message = "<div class=\"saito-chat-notice\">\n                      <span class=\"saito-mention saito-address\" data-id=\"".concat(new_member, "\">").concat(this.app.keychain.returnUsername(txmsg.invited_by), "</span>\n                      <span> added </span>\n                      <span class=\"saito-mention saito-address\" data-id=\"").concat(new_member, "\">").concat(this.app.keychain.returnUsername(new_member), "</span>\n                      <span> joined the group</span>\n                    </div>");
                tx.notice = true;
                this.addTransactionToGroup(group, tx);
              }

              //Don't overwrite admin (if for some reason admin is sending a confirm)
              if (group.member_ids[new_member] !== 'admin') {
                group.member_ids[new_member] = 1;
              }
              this.app.connection.emit('chat-popup-render-request', group);
              this.sendUpdateGroupTransaction(group, new_member);
              if (tx.isTo(this.publicKey)) {
                siteMessage("".concat(this.app.keychain.returnUsername(new_member), " joined ").concat(group.name), 3000);
              }
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function receiveJoinGroupTransaction(_x13) {
        return _receiveJoinGroupTransaction.apply(this, arguments);
      }
      return receiveJoinGroupTransaction;
    }() //
    //
    //
  }, {
    key: "sendUpdateGroupTransaction",
    value: function () {
      var _sendUpdateGroupTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(group) {
        var target,
          newtx,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              target = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : null;
              _context10.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(group.id);
            case 1:
              newtx = _context10.v;
              if (!(newtx == null)) {
                _context10.n = 2;
                break;
              }
              return _context10.a(2);
            case 2:
              newtx.msg = {
                module: 'Chat',
                request: 'chat update',
                group_name: group.name,
                group_id: group.id,
                member_ids: group.member_ids
              };

              //
              // These are stripped down objects, much smaller than the original transactions
              // but still (hopefully) compatible with the addTransactionToGroup logic
              //
              if (target) {
                console.log("Sending ".concat(group.txs.length, " last messages to ").concat(target));
                newtx.msg.chat_history = group.txs;
                newtx.addTo(target);
              }
              _context10.n = 3;
              return newtx.sign();
            case 3:
              _context10.n = 4;
              return this.app.network.propagateTransaction(newtx);
            case 4:
              this.app.connection.emit('relay-send-message', {
                request: 'chat relay',
                recipient: group.members,
                data: newtx.toJson()
              });
            case 5:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function sendUpdateGroupTransaction(_x14) {
        return _sendUpdateGroupTransaction.apply(this, arguments);
      }
      return sendUpdateGroupTransaction;
    }()
  }, {
    key: "receiveUpdateGroupTransaction",
    value: function () {
      var _receiveUpdateGroupTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(tx) {
        var txmsg, group, sender, i, _i2, notice, _i3, add_member, j, _iterator9, _step9, _t3, _t4;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              txmsg = tx.returnMessage();
              group = this.returnGroup(txmsg.group_id);
              if (group) {
                _context11.n = 1;
                break;
              }
              console.warn('Chat group not found');
              return _context11.a(2);
            case 1:
              if (!tx.isTo(group.id)) {
                _context11.n = 9;
                break;
              }
              console.log('CHAT UPDATE:', txmsg);
              sender = tx.from[0].publicKey;
              if (!(group.member_ids[sender] !== 'admin')) {
                _context11.n = 2;
                break;
              }
              if (tx.isTo(this.publicKey)) {
                console.log('Accepting info from other group members');
                for (i in txmsg.member_ids) {
                  group.member_ids[i] = txmsg.member_ids[i];
                }
                for (_i2 in group.member_ids) {
                  if (group.member_ids[_i2] !== -1) {
                    if (!group.members.includes(_i2)) {
                      group.members.push(_i2);
                    }
                  }
                }
              } else {
                console.log('Non-admin attempting to change the group!');
              }
              return _context11.a(2);
            case 2:
              notice = '';
              if (txmsg.group_name !== group.name) {
                notice += "<div class=\"saito-chat-notice\">\n        <span class=\"saito-mention saito-address\" data-id=\"".concat(sender, "\">").concat(this.app.keychain.returnUsername(sender), "</span>\n        <span> changed the name of the group to ").concat(txmsg.group_name, "</span></div>");
                group.name = txmsg.group_name;
              }
              _t3 = _regeneratorKeys(txmsg.member_ids);
            case 3:
              if ((_t4 = _t3()).done) {
                _context11.n = 8;
                break;
              }
              _i3 = _t4.value;
              add_member = 0;
              if (!(txmsg.member_ids[_i3] !== group.member_ids[_i3])) {
                _context11.n = 7;
                break;
              }
              if (txmsg.member_ids[_i3] == 'admin') {
                group.member_ids[_i3] = 'admin';
                notice += "<div class=\"saito-chat-notice\">\n                    <span class=\"saito-mention saito-address\" data-id=\"".concat(sender, "\">").concat(this.app.keychain.returnUsername(sender), "</span>\n                    <span>granted admin rights to </span>\n                    <span class=\"saito-mention saito-address\" data-id=\"").concat(_i3, "\">").concat(this.app.keychain.returnUsername(_i3), "</span>\n                    </div>");
                add_member = 1;
              }
              if (txmsg.member_ids[_i3] == 1) {
                add_member = 1;
              }
              if (txmsg.member_ids[_i3] == -1) {
                add_member = -1;
              }
              if (!add_member) {
                _context11.n = 7;
                break;
              }
              //change status in member_ids
              group.member_ids[_i3] = txmsg.member_ids[_i3];
              if (!(add_member > 0 && !group.members.includes(_i3))) {
                _context11.n = 4;
                break;
              }
              //add member
              group.members.push(_i3);
              _context11.n = 7;
              break;
            case 4:
              if (!(add_member < 0 && group.members.includes(_i3))) {
                _context11.n = 7;
                break;
              }
              j = 0;
            case 5:
              if (!(j < group.members.length)) {
                _context11.n = 7;
                break;
              }
              if (!(group.members[j] == _i3)) {
                _context11.n = 6;
                break;
              }
              group.members.splice(j, 1);
              return _context11.a(3, 7);
            case 6:
              j++;
              _context11.n = 5;
              break;
            case 7:
              _context11.n = 3;
              break;
            case 8:
              console.log('CHAT group update:', group);
              if (notice) {
                tx.msg.message = notice;
                tx.notice = true;
                this.addTransactionToGroup(group, tx);
              }
              if (txmsg.chat_history) {
                _iterator9 = _createForOfIteratorHelper(txmsg.chat_history);
                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    t = _step9.value;
                    this.addTransactionToGroup(group, t);
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
              }
              this.app.connection.emit('chat-popup-render-request', group);
            case 9:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function receiveUpdateGroupTransaction(_x15) {
        return _receiveUpdateGroupTransaction.apply(this, arguments);
      }
      return receiveUpdateGroupTransaction;
    }()
  }, {
    key: "sendRemoveMemberTransaction",
    value: function () {
      var _sendRemoveMemberTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(group, member) {
        var newtx;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(group.id);
            case 1:
              newtx = _context12.v;
              if (!(newtx == null)) {
                _context12.n = 2;
                break;
              }
              return _context12.a(2);
            case 2:
              newtx.msg = {
                module: 'Chat',
                request: 'chat remove',
                group_id: group.id,
                member_id: member
              };
              _context12.n = 3;
              return newtx.sign();
            case 3:
              _context12.n = 4;
              return this.app.network.propagateTransaction(newtx);
            case 4:
              this.app.connection.emit('relay-send-message', {
                request: 'chat relay',
                recipient: group.members,
                data: newtx.toJson()
              });
            case 5:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function sendRemoveMemberTransaction(_x16, _x17) {
        return _sendRemoveMemberTransaction.apply(this, arguments);
      }
      return sendRemoveMemberTransaction;
    }()
  }, {
    key: "receiveRemoveMemberTransaction",
    value: function () {
      var _receiveRemoveMemberTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(tx) {
        var txmsg, group, sender, i;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              txmsg = tx.returnMessage();
              group = this.returnGroup(txmsg.group_id);
              if (group) {
                _context13.n = 1;
                break;
              }
              console.warn("Chat group doesn't exist locally");
              return _context13.a(2);
            case 1:
              if (!tx.isTo(group.id)) {
                _context13.n = 7;
                break;
              }
              sender = tx.from[0].publicKey;
              if (!(group.member_ids[sender] == 'admin' || sender == txmsg.member_id)) {
                _context13.n = 7;
                break;
              }
              i = 0;
            case 2:
              if (!(i < group.members.length)) {
                _context13.n = 4;
                break;
              }
              if (!(group.members[i] == txmsg.member_id)) {
                _context13.n = 3;
                break;
              }
              group.members.splice(i, 1);
              return _context13.a(3, 4);
            case 3:
              i++;
              _context13.n = 2;
              break;
            case 4:
              if (!(this.publicKey == txmsg.member_id)) {
                _context13.n = 6;
                break;
              }
              _context13.n = 5;
              return this.deleteChatGroup(group);
            case 5:
              _context13.n = 7;
              break;
            case 6:
              if (tx.isFrom(txmsg.member_id)) {
                group.member_ids[txmsg.member_id] = 0;
                tx.msg.message = "<div class=\"saito-chat-notice\">\n                          <span class=\"saito-mention saito-address\" data-id=\"".concat(txmsg.member_id, "\">").concat(this.app.keychain.returnUsername(txmsg.member_id), "</span>\n                          <span>left the group</span></div>");
              } else {
                group.member_ids[txmsg.member_id] = -1;
                tx.msg.message = "<div class=\"saito-chat-notice\">\n                          <span class=\"saito-mention saito-address\" data-id=\"".concat(sender, "\">").concat(this.app.keychain.returnUsername(sender), "</span>\n                          <span> kicked </span>\n                          <span class=\"saito-mention saito-address\" data-id=\"").concat(txmsg.member_id, "\">").concat(this.app.keychain.returnUsername(txmsg.member_id), "</span>\n                          <span> out of the group</span>\n                        </div>");
              }

              //Flag this as a pseudo chat transaction
              tx.notice = true;
              this.addTransactionToGroup(group, tx);
              this.app.connection.emit('chat-manager-opens-group', group);
              this.app.connection.emit('chat-popup-render-request', group);
            case 7:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function receiveRemoveMemberTransaction(_x18) {
        return _receiveRemoveMemberTransaction.apply(this, arguments);
      }
      return receiveRemoveMemberTransaction;
    }()
  }, {
    key: "createChatTransaction",
    value: function () {
      var _createChatTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(group_id) {
        var _this$communityGroup2;
        var msg,
          to_keys,
          newtx,
          wallet_balance,
          secret_holder,
          group,
          members,
          i,
          _iterator0,
          _step0,
          mention,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              msg = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : '';
              to_keys = _args14.length > 2 && _args14[2] !== undefined ? _args14[2] : [];
              _context14.n = 1;
              return this.app.wallet.createUnsignedTransaction(this.publicKey, BigInt(0), BigInt(0));
            case 1:
              newtx = _context14.v;
              if (!(newtx == null)) {
                _context14.n = 2;
                break;
              }
              console.error('Null tx created for chat');
              return _context14.a(2, null);
            case 2:
              _context14.n = 3;
              return this.app.wallet.getBalance('SAITO');
            case 3:
              wallet_balance = _context14.v;
              if (!(wallet_balance == 0 && ((_this$communityGroup2 = this.communityGroup) === null || _this$communityGroup2 === void 0 ? void 0 : _this$communityGroup2.id) == group_id && this.app.BROWSER == 1 && this.app.browser.stripHtml(msg).length >= 1000)) {
                _context14.n = 4;
                break;
              }
              siteMessage('Insufficient SAITO to Send Large Messages in Community Chat...', 3000);
              return _context14.a(2, null);
            case 4:
              secret_holder = '';
              group = this.returnGroup(group_id);
              members = this.returnMembers(group_id);
              if (group !== null && group !== void 0 && group.member_ids) {
                //
                // watch key-based groups just need to address to the group public key
                //
                newtx.addTo(group_id);
              } else {
                //
                // otherwise, send to every member of group, which is typically 1 person
                //
                for (i = 0; i < members.length; i++) {
                  // for encrypted dms, who is the other person i am dm-ing
                  if (members[i] !== this.publicKey) {
                    secret_holder = members[i];
                  }
                  newtx.addTo(members[i]);
                }
              }

              //
              // Make sure tx is addressed to anyone with a special mention/notification
              //
              _iterator0 = _createForOfIteratorHelper(to_keys);
              try {
                for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
                  mention = _step0.value;
                  if (!members.includes(mention)) {
                    newtx.addTo(mention);
                  }
                }

                //
                // create chat message
                //
              } catch (err) {
                _iterator0.e(err);
              } finally {
                _iterator0.f();
              }
              newtx.msg = {
                module: 'Chat',
                request: 'chat message',
                group_id: group_id,
                message: msg,
                timestamp: new Date().getTime(),
                mentioned: to_keys
              };

              //
              // add name (?) -- TO DO -- clean up the old code for managing dynamic naming
              //
              if (group) {
                if (!members.includes(group.name)) {
                  newtx.msg.group_name = group.name;
                }
              }

              // DMs
              if (!(members.length == 2 && !(group !== null && group !== void 0 && group.member_ids))) {
                _context14.n = 6;
                break;
              }
              _context14.n = 5;
              return this.app.wallet.signAndEncryptTransaction(newtx, secret_holder);
            case 5:
              newtx = _context14.v;
              _context14.n = 7;
              break;
            case 6:
              _context14.n = 7;
              return newtx.sign();
            case 7:
              if (!(msg.substring(0, 4) == '<img')) {
                _context14.n = 9;
                break;
              }
              if (!this.inTransitImageMsgSig) {
                _context14.n = 8;
                break;
              }
              salert('Image already being sent');
              return _context14.a(2);
            case 8:
              this.inTransitImageMsgSig = newtx.signature;
            case 9:
              _context14.n = 10;
              return this.app.network.propagateTransaction(newtx);
            case 10:
              this.app.connection.emit('relay-send-message', {
                recipient: group.members,
                request: 'chat relay',
                data: newtx.toJson()
              });
              return _context14.a(2, newtx);
          }
        }, _callee14, this);
      }));
      function createChatTransaction(_x19) {
        return _createChatTransaction.apply(this, arguments);
      }
      return createChatTransaction;
    }()
    /**
     * Everyone receives the chat message (via the Relay)
     * So we make sure here it is actually for us (otherwise will be encrypted gobbledygook)
     */
  }, {
    key: "receiveChatTransaction",
    value: function () {
      var _receiveChatTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(tx) {
        var _group2;
        var blk,
          txmsg,
          group,
          members,
          x,
          sender,
          i,
          key,
          new_message,
          _args15 = arguments,
          _t5;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              blk = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : false;
              if (this.inTransitImageMsgSig == tx.signature) {
                this.inTransitImageMsgSig = null;
              }
              txmsg = '';
              _context15.p = 1;
              if (!tx.decryptMessage) {
                _context15.n = 2;
                break;
              }
              _context15.n = 2;
              return tx.decryptMessage(this.app);
            case 2:
              if (tx.returnMessage) {
                txmsg = tx.returnMessage();
              } else {
                txmsg = tx.msg;
              }
              _context15.n = 4;
              break;
            case 3:
              _context15.p = 3;
              _t5 = _context15.v;
              console.log('ERROR: ' + JSON.stringify(_t5));
            case 4:
              if (this.debug) {
                console.log('Receive Chat Transaction: ', blk);
                // console.log(JSON.parse(JSON.stringify(tx)));
                //console.log(JSON.parse(JSON.stringify(txmsg)));
              }
              if (!(this.app.modules.moderate(tx) == -1)) {
                _context15.n = 5;
                break;
              }
              console.log('Refuse chat message from blocked account');
              return _context15.a(2);
            case 5:
              //
              // save transactions if getting chat tx over chain
              // and only trigger if you were the sender
              // (should less the duplication effect)
              //
              if (blk) {
                if (this.app.BROWSER) {
                  if (tx.isFrom(this.publicKey)) {
                    console.log('Save My Sent Chat TX : ', txmsg.group_id);
                    this.app.storage.saveTransaction(tx, {
                      field3: txmsg.group_id
                    }, null, blk);
                  }
                } /*else if (tx.isTo(this.publicKey)) {
                  console.log('Save Public Chat TX : ', txmsg.group_id);
                  await this.app.storage.saveTransaction(tx, {
                    field3: txmsg.group_id
                  });
                  }*/
              }
              group = this.returnGroup(txmsg.group_id);
              if (group) {
                _context15.n = 7;
                break;
              }
              if (tx.isTo(this.publicKey)) {
                _context15.n = 6;
                break;
              }
              if (this.debug) {
                console.log('Chat message not for me');
              }
              return _context15.a(2);
            case 6:
              //
              // Create a chat group on the fly if properly addressed to me
              //
              members = [];
              for (x = 0; x < tx.to.length; x++) {
                if (!members.includes(tx.to[x].publicKey)) {
                  members.push(tx.to[x].publicKey);
                }
              }
              group = this.returnOrCreateChatGroupFromMembers(members, txmsg.group_name);
              group.id = txmsg.group_id;
            case 7:
              if (!((_group2 = group) !== null && _group2 !== void 0 && _group2.member_ids)) {
                _context15.n = 10;
                break;
              }
              sender = tx.from[0].publicKey;
              if (!(group.member_ids[sender] == -1)) {
                _context15.n = 8;
                break;
              }
              console.log('Refuse chat message from banned account');
              return _context15.a(2);
            case 8:
              if (!group.member_ids[sender]) {
                //fall back for adding group members to my list based on them chatting
                group.member_ids[sender] = 1;
              }
            case 9:
              if (!group.members.includes(sender)) {
                group.members.push(sender);
              }
            case 10:
              //Do the safety check for duplicate messages inside addTransactionToGroup!

              if (this.addTransactionToGroup(group, tx)) {
                //
                // Just a little warning that it isn't nice to @ people if you blocked them and they cannot reply
                //
                if (tx.isFrom(this.publicKey)) {
                  for (i = 0; i < tx.to.length; i++) {
                    key = tx.to[i].publicKey;
                    if (this.app.modules.moderateAddress(key) == -1 && !this.communityGroup.members.includes(key)) {
                      new_message = "<div class=\"saito-chat-notice\">\n              <span class=\"saito-mention saito-address\" data-id=\"".concat(key, "\">").concat(this.app.keychain.returnUsername(key), "</span>\n              <span> is blocked and cannot respond </span>\n            </div>");
                      group.txs.push({
                        signature: tx.signature + '1',
                        timestamp: new Date().getTime(),
                        from: [],
                        msg: new_message,
                        mentioned: [],
                        notice: true,
                        likes: 0,
                        liked_by: {}
                      });
                    }
                  }
                }
              }
              this.app.connection.emit('chat-popup-render-request', group);
            case 11:
              return _context15.a(2);
          }
        }, _callee15, this, [[1, 3]]);
      }));
      function receiveChatTransaction(_x20) {
        return _receiveChatTransaction.apply(this, arguments);
      }
      return receiveChatTransaction;
    }() //////////////////
    // UI Functions //
    //////////////////
    //
    // These three functions replace all the templates to format the messages into
    // single speaker blocks
    //
  }, {
    key: "returnChatBody",
    value: function returnChatBody(group_id) {
      var _this3 = this;
      var chat_self = this;
      var html = '';
      var group = this.returnGroup(group_id);
      if (!group) {
        return '';
      }
      var message_blocks = this.createMessageBlocks(group);
      var new_message_flag = false;
      var solo_link_regex = /^<p><a.*<\/a><\/p>$/;
      var _iterator1 = _createForOfIteratorHelper(message_blocks),
        _step1;
      try {
        var _loop2 = function _loop2() {
          var block = _step1.value;
          var ts = 0;
          if (block !== null && block !== void 0 && block.date) {
            html += "<div class=\"saito-time-stamp\">".concat(block.date, "</div>");
          } else if (block !== null && block !== void 0 && block.notice) {
            html += "<div class=\"saito-time-stamp\">".concat(block.notice, "</div>");
          } else {
            if (block.length > 0) {
              var sender = '';
              var msg = '';
              var _loop3 = function _loop3(z) {
                var _block$z;
                ts = ts || block[z].timestamp;
                sender = block[z].from[0];

                // replace @mentions with saito treated address
                block[z].msg = chat_self.app.browser.markupMentions(block[z].msg);

                // Get my like status
                var liked = '';
                var like_number;
                _this3.groups.forEach(function (group) {
                  group.txs.forEach(function (tx) {
                    if (tx.signature === block[z].signature) {
                      if (!tx.liked_by) tx.liked_by = {};
                      if (!tx.likes) tx.likes = 0;
                      if (tx.liked_by[_this3.publicKey] === true) {
                        liked = 'liked';
                      }
                      like_number = tx.likes;
                    }
                  });
                });
                var replyButton = "\n              <div data-id=\"".concat(block[z].signature, "\" data-href=\"").concat(sender + ts, "\" class=\"saito-userline-reply\">\n                <div class=\"chat-like chat-message-action\"><i class=\"fas fa-thumbs-up  ").concat(liked, "\"></i></div> \n                <div class=\"chat-copy chat-message-action\"><i class=\"fas fa-copy\"></i></div>\n                <div class=\"chat-reply chat-message-action\"><i class=\"fas fa-reply\"></i></div>\n                <div class=\"saito-chat-line-timestamp\">\n                  <span>").concat(_this3.app.browser.returnTime(ts), "</span>\n                </div>\n              </div>");
                msg += "<div class=\"chat-message-line message-".concat(block[z].signature);
                if ((_block$z = block[z]) !== null && _block$z !== void 0 && _block$z.flag_message) {
                  msg += ' user-mentioned-in-chat-line';
                }
                if (new_message_flag) {
                  msg += ' new-message';
                }
                msg += "\">";
                if (block[z].msg.indexOf('<img') != 0) {
                  var saniText = _this3.app.browser.sanitize(block[z].msg, true);
                  if (saniText.includes('\n')) {
                    msg += saniText.split('\n').join('<br>');
                  } else {
                    if (block[z].link_properties) {
                      if (solo_link_regex.test(saniText)) {
                        //console.log('Chat block is just a link: ', saniText);
                      } else {
                        msg += saniText;
                      }
                      msg += "<div class='link-preview link-".concat(block[z].signature, "'></div>");
                      if (!(group !== null && group !== void 0 && group.links)) {
                        group.links = {};
                      }
                      if (!group.links[block[z].signature]) {
                        group.links[block[z].signature] = new Link(_this3.app, _this3, ".link-".concat(block[z].signature), block[z].link, block[z].link_properties);
                      }
                    } else {
                      msg += saniText;
                    }
                  }
                } else {
                  msg += block[z].msg.substring(0, block[z].msg.indexOf('>') + 1);
                }
                msg += like_number > 0 ? "<div class=\"chat-likes\"> <i class=\"fas fa-thumbs-up\"></i><div class=\"chat-like-number\">".concat(like_number, "</div> </div>") : "<div></div>";
                msg += "".concat(replyButton, "</div>");
                if (group !== null && group !== void 0 && group.last_read_message && block[z].signature == group.last_read_message && group.unread > 0) {
                  console.log('Mark remaining messages as new!');
                  new_message_flag = true;
                }
                if (block[z].link_properties) {}
              };
              for (var z = 0; z < block.length; z++) {
                _loop3(z);
              }

              //
              // check blacklist before adding to chat body -- to filter post-hoc
              //
              if (_this3.app.modules.moderateAddress(sender) !== -1) {
                //Use FA 5 so compatible in games (until we upgrade everything to FA6)
                html += "".concat(SaitoUserTemplate({
                  app: _this3.app,
                  publicKey: sender,
                  notice: msg,
                  fourthelem: '',
                  id: sender + ts
                }));
              }
            }
          }
        };
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      if (!html) {
        html = "<div class=\"saito-time-stamp\">say hello</div>";
      }
      group.mentioned = false;

      //Save the status that we have read these messages
      this.saveChatGroup(group);
      return html;
    }
  }, {
    key: "renderLinks",
    value: function renderLinks(group_id) {
      var group = this.returnGroup(group_id);
      for (var a in group === null || group === void 0 ? void 0 : group.links) {
        group.links[a].render();
      }
    }
  }, {
    key: "createMessageBlocks",
    value: function createMessageBlocks(group) {
      var blocks = [];
      var block = [];
      var last_message_sender = '';
      var last_message_ts = 0;
      var last = new Date(0);
      var _iterator10 = _createForOfIteratorHelper(group === null || group === void 0 ? void 0 : group.txs),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var minimized_tx = _step10.value;
          //Same Sender -- keep building block
          var next = new Date(minimized_tx.timestamp);
          if (minimized_tx !== null && minimized_tx !== void 0 && minimized_tx.notice) {
            if (block.length > 0) {
              blocks.push(block);
              block = [];
            }
            blocks.push({
              notice: minimized_tx.msg
            });
            last_message_sender = '';
            continue;
          }
          if (minimized_tx.from.includes(last_message_sender) && minimized_tx.timestamp - last_message_ts < 300000 && next.getDate() == last.getDate()) {
            block.push(minimized_tx);
          } else {
            //Start new block
            if (block.length > 0) {
              blocks.push(block);
              block = [];
            }
            if (next.getDate() !== last.getDate()) {
              if (next.toDateString() == new Date().toDateString()) {
                blocks.push({
                  date: 'Today'
                });
              } else {
                blocks.push({
                  date: next.toDateString()
                });
              }
            }
            block.push(minimized_tx);
          }
          last_message_sender = minimized_tx.from[0];
          last_message_ts = minimized_tx.timestamp;
          last = next;
          if (minimized_tx !== null && minimized_tx !== void 0 && minimized_tx.link_properties) {
            // Next message after a link starts a new block!
            last_message_sender = '';
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      if (block.length > 0) {
        blocks.push(block);
      }
      return blocks;
    }

    //
    //
    //
  }, {
    key: "addTransactionToGroup",
    value: function addTransactionToGroup(group, tx) {
      var _txmsg,
        _this4 = this;
      var historic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // Limit live memory
      // I may be overly worried about memory leaks
      // If users can dynamically load older messages, this limit creates a problem
      // when scrolling back in time
      if (!this.app.BROWSER) {
        while (group.txs.length > 200) {
          group.txs.shift();
        }
      }

      //Have we already inserted this message into the chat?
      for (var z = 0; z < group.txs.length; z++) {
        if (group.txs[z].signature === tx.signature) {
          return 0;
        }
      }
      var txmsg = tx.msg;
      try {
        txmsg = tx.returnMessage();
      } catch (err) {}
      if (this.debug) {
        console.debug('Adding Chat TX to group: ', txmsg);
      }
      var content = txmsg.message || txmsg;
      var mentions = ((_txmsg = txmsg) === null || _txmsg === void 0 ? void 0 : _txmsg.mentioned) || (tx === null || tx === void 0 ? void 0 : tx.mentioned) || [];
      if (!content || typeof content !== 'string') {
        //console.warn('Not a chat message?');
        //console.log(tx);
        return 0;
      }
      var new_message = {
        signature: tx.signature,
        timestamp: tx.timestamp,
        from: [],
        msg: content,
        mentioned: mentions,
        likes: 0,
        liked_by: {}
      };
      if (!historic && group.last_update > new_message.timestamp) {
        console.log("Fake the timestamp so chats don't rearrange...");
        new_message.timestamp = group.last_update + 1;
      }
      if (tx !== null && tx !== void 0 && tx.notice) {
        new_message.notice = tx.notice;
      }

      // Need to rewrite this!!!
      if (this.app.BROWSER && new_message.mentioned.includes(this.publicKey)) {
        group.mentioned = true;
        new_message.flag_message = true;
      }

      //Keep the from array just in case....
      var _iterator11 = _createForOfIteratorHelper(tx.from),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var sender = _step11.value;
          var key = (sender === null || sender === void 0 ? void 0 : sender.publicKey) || sender;
          if (!new_message.from.includes(key)) {
            new_message.from.push(key);
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      var insertion_index = 0;
      for (var i = 0; i < group.txs.length; i++) {
        if (group.txs[i].signature === tx.signature) {
          if (this.debug) {
            console.log('duplicate');
          }
          return 0;
        }
        if (new_message.timestamp < group.txs[i].timestamp) {
          //if (this.debug) {
          console.log('CHAT message out of order ' + i, JSON.parse(JSON.stringify(new_message)));
          //}
          break;
        }
        insertion_index++;
      }
      if (!new_message.from.includes(this.publicKey)) {
        group.unread++;
      } else {
        group.last_read_message = tx.signature;
      }

      //Handle new messages (possibly out of order)

      group.txs.splice(insertion_index, 0, new_message);
      group.last_update = Math.max(group.last_update, new_message.timestamp);
      if (!this.app.BROWSER) {
        var link = this.app.browser.extractFirstValidURL(content);
        if (link && this.online) {
          new_message.link = link;
          this.app.server.fetchOpenGraphProperties(new_message.link, function (res) {
            new_message.link_properties = res;
            // send out a broadcast with an update
            _this4.notifyPeers({
              group_id: group.id,
              new_message: new_message
            });
          });
        }
        return 0;
      }
      if (this.debug) {
        console.log("new msg: ".concat(group.unread, " unread"));
        console.log(JSON.parse(JSON.stringify(new_message)));
      }
      if (!new_message.from.includes(this.publicKey)) {
        //Flash new message in browser tab
        if (!group.muted) {
          this.notification(group);

          // Flag the group that there is a new message
          // This is so we can add an animation effect on rerender
          // and will be reset there
          //
          group.notification = true;
        }

        //Add liveness indicator to group
        this.app.connection.emit('group-is-active', group);
      }

      //Save to IndexedDB Here
      if (this.loading <= 0) {
        this.saveChatGroup(group);
      } else {
        console.warn("Not saving because in loading mode (".concat(this.loading, ")"));
      }
      return 1;
    }

    // /**
    //  * Asynchronously creates a "like" transaction for a chat message.
    //  *
    //  */
  }, {
    key: "createChatLikeTransaction",
    value: function () {
      var _createChatLikeTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(group, signature, mentioned) {
        var newtx, i;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              _context16.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context16.v;
              if (!(newtx == null)) {
                _context16.n = 2;
                break;
              }
              console.error('Chat: Failed to create a new transaction');
              return _context16.a(2, null);
            case 2:
              if (mentioned) {
                console.log('ADDRESS TO: ', mentioned);
                newtx.addTo(mentioned);
              }
              if (group !== null && group !== void 0 && group.member_ids) {
                newtx.addTo(group.id);
              } else {
                for (i = 0; i < group.members.length; i++) {
                  newtx.addTo(group.members[i]);
                }
              }
              newtx.msg = {
                module: 'Chat',
                request: 'chat like',
                group_id: group.id,
                sender: this.publicKey,
                signature: signature,
                mentioned: mentioned
              };
              _context16.n = 3;
              return newtx.sign();
            case 3:
              _context16.n = 4;
              return this.app.network.propagateTransaction(newtx);
            case 4:
              this.app.connection.emit('relay-send-message', {
                recipient: group.members,
                request: 'chat relay',
                data: newtx.toJson()
              });
              return _context16.a(2, newtx);
          }
        }, _callee16, this);
      }));
      function createChatLikeTransaction(_x21, _x22, _x23) {
        return _createChatLikeTransaction.apply(this, arguments);
      }
      return createChatLikeTransaction;
    }()
    /**
     * Asynchronously handles the receipt of a "like" transaction.
     */
  }, {
    key: "receiveChatLikeTransaction",
    value: function () {
      var _receiveChatLikeTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(tx) {
        var _tx$returnMessage, group_id, signature, sender, group;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _tx$returnMessage = tx.returnMessage(), group_id = _tx$returnMessage.group_id, signature = _tx$returnMessage.signature, sender = _tx$returnMessage.sender;
              group = this.returnGroup(group_id);
              if (group) {
                _context17.n = 1;
                break;
              }
              console.warn('Chat: Group not found for the given group ID');
              return _context17.a(2);
            case 1:
              group.txs.forEach(function (transaction) {
                if (transaction.signature === signature) {
                  transaction.liked_by = transaction.liked_by || {};
                  transaction.likes = transaction.likes || 0;
                  if (transaction.liked_by[sender]) {
                    transaction.likes--;
                    transaction.liked_by[sender] = false;
                  } else {
                    transaction.likes++;
                    transaction.liked_by[sender] = true;
                  }
                }
              });
              this.app.connection.emit('chat-popup-render-request', group);
            case 2:
              return _context17.a(2);
          }
        }, _callee17, this);
      }));
      function receiveChatLikeTransaction(_x24) {
        return _receiveChatLikeTransaction.apply(this, arguments);
      }
      return receiveChatLikeTransaction;
    }() ///////////////////
    // CHAT UTILITIES //
    ///////////////////
  }, {
    key: "createGroupIdFromMembers",
    value: function createGroupIdFromMembers() {
      var members = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (members == null) {
        return '';
      }
      var clean_array = [];
      var _iterator12 = _createForOfIteratorHelper(members),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var member = _step12.value;
          clean_array.push(member);
        }
        //So David + Richard == Richard + David
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      clean_array.sort();
      return this.app.crypto.hash("".concat(clean_array.join('_')));
    }

    //
    // if we already have a group with these members,
    // returnOrCreateChatGroupFromMembers will find and return it, otherwise
    // it makes a new group
    //
  }, {
    key: "returnOrCreateChatGroupFromMembers",
    value: function returnOrCreateChatGroupFromMembers() {
      var members = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var update_name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!members) {
        return null;
      }
      var id;

      //This might keep persistence across server resets
      if (name === this.communityGroupName) {
        id = this.app.crypto.hash(this.communityGroupName);
      } else {
        //Make sure that I am part of the chat group
        if (!members.includes(this.publicKey)) {
          members.push(this.publicKey);
        }
        id = this.createGroupIdFromMembers(members);
      }
      if (!id) {
        console.warn('Chat error: ', members);
        console.trace();
      }
      if (name == null) {
        name = '';
        for (var i = 0; i < members.length; i++) {
          if (members[i] != this.publicKey) {
            name += members[i] + ', ';
          }
        }
        if (!name) {
          name = 'me';
        } else {
          name = name.substring(0, name.length - 2);
        }
      }
      for (var _i4 = 0; _i4 < this.groups.length; _i4++) {
        if (this.groups[_i4].id == id) {
          if (update_name && this.groups[_i4].name != name) {
            this.groups[_i4].old_name = this.groups[_i4].name;
            this.groups[_i4].name = name;
          } else if (this.groups[_i4].old_name) {
            this.groups[_i4].name = this.groups[_i4].old_name;
            delete this.groups[_i4].old_name;
          }
          return this.groups[_i4];
        }
      }
      if (this.debug) {
        console.log(JSON.stringify(members));
      }
      var newGroup = {
        id: id,
        members: members,
        name: name,
        txs: [],
        unread: 0,
        last_update: 0
      };

      //Prepend the community chat
      if (name === this.communityGroupName) {
        this.groups.unshift(newGroup);
      } else {
        this.groups.push(newGroup);
      }
      this.app.connection.emit('chat-manager-render-request');
      return newGroup;
    }
  }, {
    key: "returnGroup",
    value: function returnGroup(group_id) {
      for (var i = 0; i < this.groups.length; i++) {
        if (group_id === this.groups[i].id) {
          return this.groups[i];
        }
      }
      return null;
    }
  }, {
    key: "returnGroupByMemberPublickey",
    value: function returnGroupByMemberPublickey(publicKey) {
      for (var i = 0; i < this.groups.length; i++) {
        if (this.groups[i].members.includes(publicKey)) {
          return this.groups[i];
        }
      }
      return null;
    }
  }, {
    key: "returnMembers",
    value: function returnMembers(group_id) {
      for (var i = 0; i < this.groups.length; i++) {
        if (group_id === this.groups[i].id) {
          if (this.groups[i].member_ids) {
            var members = [];
            var _iterator13 = _createForOfIteratorHelper(this.groups[i].members),
              _step13;
            try {
              for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                var m = _step13.value;
                if (!members.includes(m)) {
                  if (this.groups[i].member_ids[m] == 'admin' || this.groups[i].member_ids[m] == 1) {
                    members.push(m);
                  }
                }
              }
            } catch (err) {
              _iterator13.e(err);
            } finally {
              _iterator13.f();
            }
            return members;
          } else {
            return _toConsumableArray(new Set(this.groups[i].members));
          }
        }
      }
      return [];
    }
  }, {
    key: "returnGroupByName",
    value: function returnGroupByName() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      for (var i = 0; i < this.groups.length; i++) {
        if (this.groups[i].name === name) {
          return this.groups[i];
        }
      }
      return this.groups[0];
    }
  }, {
    key: "returnCommunityChat",
    value: function returnCommunityChat() {
      for (var i = 0; i < this.groups.length; i++) {
        if (this.groups[i].name === this.communityGroupName) {
          return this.groups[i];
        }
      }
      return this.groups[0];
    }
  }, {
    key: "createDefaultChatsFromKeys",
    value: function createDefaultChatsFromKeys() {
      //
      // create chatgroups from keychain -- friends only
      //
      var keys = this.app.keychain.returnKeys();
      //console.log("Populate chat list");
      for (var i = 0; i < keys.length; i++) {
        var _keys$i;
        if (keys[i].aes_publicKey && !((_keys$i = keys[i]) !== null && _keys$i !== void 0 && _keys$i.mute)) {
          this.returnOrCreateChatGroupFromMembers([keys[i].publicKey], keys[i].name, false);
        }
      }
      this.app.connection.emit('chat-manager-render-request');
    }
  }, {
    key: "getOlderTransactions",
    value: function () {
      var _getOlderTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(group_id) {
        var _this5 = this;
        var peer,
          group,
          ts,
          chat_self,
          _args19 = arguments;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              peer = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : null;
              group = this.returnGroup(group_id);
              if (group) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2);
            case 1:
              ts = new Date().getTime(); // ts of oldest message in chat group
              if (group.txs.length > 0) {
                ts = group.txs[0].timestamp;
              }
              chat_self = this;
              _context19.n = 2;
              return this.app.storage.loadTransactions({
                field3: group_id,
                limit: 50,
                created_earlier_than: ts
              }, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(txs) {
                  var tx;
                  return _regenerator().w(function (_context18) {
                    while (1) switch (_context18.n) {
                      case 0:
                        console.log("Fetched ".concat(txs === null || txs === void 0 ? void 0 : txs.length, " older chat messages from Archive"));
                        if (!txs || txs.length < 50) {
                          _this5.app.connection.emit('chat-remove-fetch-button-request', group_id);
                        }
                        if (!txs) {
                          _context18.n = 3;
                          break;
                        }
                      case 1:
                        if (!(txs.length > 0)) {
                          _context18.n = 3;
                          break;
                        }
                        //Process the chat transaction like a new message
                        tx = txs.pop();
                        _context18.n = 2;
                        return tx.decryptMessage(chat_self.app);
                      case 2:
                        chat_self.addTransactionToGroup(group, tx, true);
                        chat_self.app.connection.emit('chat-popup-render-request', group);
                        chat_self.app.connection.emit('chat-popup-scroll-top-request', group_id);
                        _context18.n = 1;
                        break;
                      case 3:
                        return _context18.a(2);
                    }
                  }, _callee18);
                }));
                return function (_x26) {
                  return _ref2.apply(this, arguments);
                };
              }(), peer);
            case 2:
              return _context19.a(2);
          }
        }, _callee19, this);
      }));
      function getOlderTransactions(_x25) {
        return _getOlderTransactions.apply(this, arguments);
      }
      return getOlderTransactions;
    }() ///////////////////
    // LOCAL STORAGE //
    ///////////////////
  }, {
    key: "loadOptions",
    value: function loadOptions() {
      var _this$app$options, _this$app$options$cha5;
      //Enforce compliance with wallet indexing
      if (!((_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && _this$app$options.chat)) {
        this.app.options.chat = {};
        this.app.options.chat.groups = [];
      } else if (Array.isArray(this.app.options.chat)) {
        var newObj = {
          groups: this.app.options.chat
        };
        this.app.options.chat = newObj;
      } else {
        var _this$app$options$cha, _this$app$options$cha3, _this$app$options$cha4;
        if (this.app.options.chat.audio_notifications !== 'undefined' && this.app.options.chat.audio_notifications !== false) {
          this.audio_notifications = this.app.options.chat.audio_notifications;
        }
        if ((_this$app$options$cha = this.app.options.chat) !== null && _this$app$options$cha !== void 0 && _this$app$options$cha.audio_chime) {
          var _this$app$options$cha2;
          this.audio_chime = (_this$app$options$cha2 = this.app.options.chat) === null || _this$app$options$cha2 === void 0 ? void 0 : _this$app$options$cha2.audio_chime;
        }
        delete this.app.options.chat.enable_notifications;
        this.auto_open_community = (_this$app$options$cha3 = this.app.options.chat) === null || _this$app$options$cha3 === void 0 ? void 0 : _this$app$options$cha3.auto_open_community;
        if ((_this$app$options$cha4 = this.app.options.chat) !== null && _this$app$options$cha4 !== void 0 && _this$app$options$cha4.black_list) {
          this.black_list = this.app.options.chat.black_list;
        }
      }
      if (((_this$app$options$cha5 = this.app.options.chat.groups) === null || _this$app$options$cha5 === void 0 ? void 0 : _this$app$options$cha5.length) == 0) {
        this.createDefaultChatsFromKeys();
      }
      this.app.storage.saveOptions();
    }
  }, {
    key: "saveOptions",
    value: function saveOptions() {
      this.app.options.chat.audio_notifications = this.audio_notifications;
      this.app.options.chat.audio_chime = this.audio_chime;
      this.app.options.chat.auto_open_community = this.auto_open_community;
      this.app.options.chat.black_list = this.black_list;
      this.app.storage.saveOptions();
    }
  }, {
    key: "loadChatGroups",
    value: function () {
      var _loadChatGroups = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
        var chat_self, count, _iterator14, _step14, g_id, value, _currentGroup, currentGroup, _t6;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.p = _context20.n) {
            case 0:
              if (this.app.BROWSER) {
                _context20.n = 1;
                break;
              }
              return _context20.a(2);
            case 1:
              chat_self = this; //console.log("Reading local DB");
              count = 0;
              _iterator14 = _createForOfIteratorHelper(this.app.options.chat.groups);
              _context20.p = 2;
              _iterator14.s();
            case 3:
              if ((_step14 = _iterator14.n()).done) {
                _context20.n = 6;
                break;
              }
              g_id = _step14.value;
              _context20.n = 4;
              return this.app.storage.getLocalForageItem("chat_".concat(g_id));
            case 4:
              value = _context20.v;
              if (value) {
                currentGroup = chat_self.returnGroup(g_id);
                if (currentGroup) {
                  value.members = currentGroup.members;
                  currentGroup = Object.assign(currentGroup, value);
                } else {
                  chat_self.groups.push(value);
                }
                currentGroup = chat_self.returnGroup(g_id);
                if (!((_currentGroup = currentGroup) !== null && _currentGroup !== void 0 && _currentGroup.last_read_message)) {
                  if (currentGroup.txs.length > 0) {
                    currentGroup.last_read_message = currentGroup.txs.slice(-1)[0].signature;
                  }
                }

                //console.log(value);
              }
            case 5:
              _context20.n = 3;
              break;
            case 6:
              _context20.n = 8;
              break;
            case 7:
              _context20.p = 7;
              _t6 = _context20.v;
              _iterator14.e(_t6);
            case 8:
              _context20.p = 8;
              _iterator14.f();
              return _context20.f(8);
            case 9:
              this.createDefaultChatsFromKeys();
            case 10:
              return _context20.a(2);
          }
        }, _callee20, this, [[2, 7, 8, 9]]);
      }));
      function loadChatGroups() {
        return _loadChatGroups.apply(this, arguments);
      }
      return loadChatGroups;
    }()
  }, {
    key: "saveChatGroup",
    value: function saveChatGroup(group) {
      if (!this.app.BROWSER || !(group !== null && group !== void 0 && group.id)) {
        return;
      }
      var chat_self = this;

      //Save group in app.options
      if (!this.app.options.chat.groups.includes(group.id)) {
        this.app.options.chat.groups.push(group.id);
      }
      this.saveOptions();
      var online_status = group.online;

      //Make deep copy
      var links = group.links;
      delete group.links; // don't save links...

      var new_group = JSON.parse(JSON.stringify(group));
      new_group.online = false;
      new_group.txs = group.txs.slice(-50);

      //Don't save the stun-specified target container
      if (new_group.target_container) {
        delete new_group.target_container;
      }
      this.app.storage.setLocalForageItem("chat_".concat(group.id), new_group);
      group.online = online_status;
      group.links = links;
    }
  }, {
    key: "deleteChatGroup",
    value: function () {
      var _deleteChatGroup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        var group,
          key_to_update,
          i,
          _this$groups$i2,
          _iterator15,
          _step15,
          member,
          _i5,
          _args21 = arguments;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              group = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : null;
              if (group) {
                _context21.n = 1;
                break;
              }
              return _context21.a(2);
            case 1:
              this.app.connection.emit('chat-popup-remove-request', group);
              key_to_update = '';
              i = 0;
            case 2:
              if (!(i < this.groups.length)) {
                _context21.n = 4;
                break;
              }
              if (!(this.groups[i].id === group.id)) {
                _context21.n = 3;
                break;
              }
              if (this.groups[i].members.length == 2 && !((_this$groups$i2 = this.groups[i]) !== null && _this$groups$i2 !== void 0 && _this$groups$i2.member_ids)) {
                _iterator15 = _createForOfIteratorHelper(this.groups[i].members);
                try {
                  for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                    member = _step15.value;
                    if (member !== this.publicKey) {
                      key_to_update = member;
                    }
                  }
                } catch (err) {
                  _iterator15.e(err);
                } finally {
                  _iterator15.f();
                }
              }
              this.groups.splice(i, 1);
              return _context21.a(3, 4);
            case 3:
              i++;
              _context21.n = 2;
              break;
            case 4:
              _i5 = 0;
            case 5:
              if (!(_i5 < this.app.options.chat.groups.length)) {
                _context21.n = 7;
                break;
              }
              if (!(this.app.options.chat.groups[_i5] === group.id)) {
                _context21.n = 6;
                break;
              }
              this.app.options.chat.groups.splice(_i5, 1);
              return _context21.a(3, 7);
            case 6:
              _i5++;
              _context21.n = 5;
              break;
            case 7:
              this.saveOptions();
              if (key_to_update) {
                this.app.keychain.addKey(key_to_update, {
                  mute: 1
                });
              }
              _context21.n = 8;
              return this.app.storage.removeLocalForageItem("chat_".concat(group.id));
            case 8:
              this.app.connection.emit('chat-manager-render-request');
            case 9:
              return _context21.a(2);
          }
        }, _callee21, this);
      }));
      function deleteChatGroup() {
        return _deleteChatGroup.apply(this, arguments);
      }
      return deleteChatGroup;
    }()
  }, {
    key: "generateChatGroupLink",
    value: function generateChatGroupLink(group) {
      var obj = {
        id: group.id,
        name: group.name,
        sender: this.publicKey
      };
      var _iterator16 = _createForOfIteratorHelper(group.members),
        _step16;
      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var mem = _step16.value;
          if (group.member_ids[mem] == 'admin') {
            obj.admin = mem;
            break;
          }
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }
      var base64obj = this.app.crypto.stringToBase64(JSON.stringify(obj));
      var link = window.location.origin + '/chat?chat_id=' + base64obj;
      navigator.clipboard.writeText(link);
      siteMessage('Link Copied', 2000);
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var mod_self = this;
      expressapp.get('/' + encodeURI(this.returnSlug()), /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(req, res) {
          var reqBaseURL;
          return _regenerator().w(function (_context22) {
            while (1) switch (_context22.n) {
              case 0:
                reqBaseURL = req.protocol + '://' + req.headers.host + '/';
                mod_self.social.url = reqBaseURL + encodeURI(mod_self.returnSlug());
                if (res.finished) {
                  _context22.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context22.a(2, res.send(HomePage(app, mod_self, app.build_number, mod_self.social)));
              case 1:
                return _context22.a(2);
            }
          }, _callee22);
        }));
        return function (_x27, _x28) {
          return _ref3.apply(this, arguments);
        };
      }());
      expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
    }
  }, {
    key: "notification",
    value: function notification(group) {
      var _this$chat_manager$po;
      /*Send System notification
        if (this.enable_notifications && !group.muted) {
          let sender = this.app.keychain.returnIdentifierByPublicKey(
            new_message.from[0],
            true
          );
          if (group.unread > 1) {
            sender += ` (${group.unread})`;
          }
          let new_msg =
            content.indexOf('<img') == 0
              ? '[image]'
              : this.app.browser.sanitize(content);
          const regex = /<blockquote>.*<\/blockquote>/is;
          new_msg = new_msg.replace(regex, 'reply: ').replace('<br>', '');
          const regex2 = /<a[^>]+>/i;
          new_msg = new_msg.replace(regex2, '').replace('</a>', '');
           this.app.browser.sendNotification(
            sender,
            new_msg,
            `chat-message-${group.id}`
          );
        }*/

      if (group.muted) {
        return;
      }

      // If we don't have chat enabled, don't chime!
      if (!this.chat_manager) {
        return;
      }
      this.app.browser.createTabNotification('New Message', group.name);
      if (!this.audio_notifications) {
        return;
      }
      if (!this.app.browser.active_tab) {
        this.playChime();
        return;
      } else if (this.audio_notifications === 'tabs') {
        return;
      }
      if (this.audio_notifications == 'groups' && (_this$chat_manager$po = this.chat_manager.popups[group.id]) !== null && _this$chat_manager$po !== void 0 && _this$chat_manager$po.is_rendered) {
        return;
      }
      this.playChime();
    }
  }, {
    key: "playChime",
    value: function playChime() {
      var _this6 = this;
      if (this.beeping) {
        console.log('Block multiple chimes');
        return;
      }
      this.beeping = setTimeout(function () {
        _this6.beeping = null;
      }, 1000);
      try {
        this.chime.play();
      } catch (err) {
        console.error(err);
      }
    }
  }]);
}(ModTemplate);
module.exports = Chat;